import { __decorate } from "tslib";
import { Vue, Component, Mixins } from "vue-property-decorator";
import ButtonApp from "@/components/ButtonApp.vue";
import ItemAdv from "@/components/ItemAdv.vue";
import { uiMapper } from "@/services/store/modules/ui/store";
import { dataMapper } from "@/services/store/modules/data/store";
const UiMappers = Vue.extend({
    computed: {
        ...uiMapper.mapState(["breakpoint"]),
    },
    methods: {
        ...uiMapper.mapMutations(["openFormCall"]),
    },
});
const DataMappers = Vue.extend({
    computed: {
        ...dataMapper.mapGetters(["formMail"]),
    },
    methods: {
        ...dataMapper.mapMutations([
            "setFormCallTitle",
            "setFormCallScreen",
            "activateFormField",
            "clearForm",
        ]),
    },
});
let ScreenAdv = class ScreenAdv extends Mixins(UiMappers, DataMappers) {
    constructor() {
        super(...arguments);
        this.adv = [
            { img: "/static/images/adv-1.png", text: "Горячее питание" },
            {
                img: "/static/images/adv-2.png",
                text: "Программа разработана методистами",
            },
            {
                img: "/static/images/adv-3.png",
                text: "Много активностей на&nbsp;свежем воздухе",
            },
            {
                img: "/static/images/adv-4.png",
                text: "Ежедневные отчеты в&nbsp;чат родителей",
            },
            {
                img: "/static/images/adv-5.png",
                text: "Все вожатые с&nbsp;пед.образованием",
            },
            {
                img: "/static/images/adv-6.png",
                text: "Много фото и&nbsp;видео о&nbsp;прошедшем дне",
            },
            { img: "/static/images/adv-7.png", text: "Контроль доступа в&nbsp;центр" },
            { img: "/static/images/adv-8.png", text: "Климат-контроль, санобработка" },
        ];
    }
    get isGtMd() {
        return this.breakpoint === "lg" || this.breakpoint === "xl";
    }
    get isLtMd() {
        return this.breakpoint === "xs" || this.breakpoint === "sm";
    }
    get itemsPerRow() {
        if (this.isLtMd)
            return 1;
        else
            return 4;
    }
    get rowsAmount() {
        return this.adv.length / this.itemsPerRow;
    }
    get formCallMail() {
        return this.formMail("callback");
    }
    async onOpenFormClick() {
        this.clearForm("callback");
        await this.$nextTick();
        this.setFormCallTitle("Записаться на пробное занятие");
        this.setFormCallScreen("Экран 06");
        this.activateFormField(this.formCallMail);
        this.openFormCall();
    }
};
ScreenAdv = __decorate([
    Component({
        components: {
            ButtonApp,
            ItemAdv,
        },
    })
], ScreenAdv);
export default ScreenAdv;
